import { render, staticRenderFns } from "./detial.vue?vue&type=template&id=2321ab88&scoped=true&"
import script from "./detial.vue?vue&type=script&lang=js&"
export * from "./detial.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2321ab88",
  null
  
)

export default component.exports